import { token } from 'brandi';
export const V1_TOKENS = {
    linkWrapperHost: token('linkWrapperHost'),
    linkWrapperFns: token('linkWrapperFnSet'),
};
//# sourceMappingURL=v1Tokens.js.map